import React from 'react'
import "../../styles/s_machine.css"
import Prodcard1 from '../../components/prodcards/Prodcard'
import img14 from '../../img/PastefM/14.png'
import img15 from '../../img/PastefM/15.png'
import img16 from '../../img/PastefM/16.png'
import img17 from '../../img/PastefM/17.png'


export const PastefM = () => {
    const des= {
        sam: ['Voltage-220V/50Hz',
          'Power-20',
          'Filling Range -10-100/50-500/100-1000',
          'Filling Capacity -10-18',
          'Filing Accuracy - <1%',
          'Dimension -100*50*105',
          'Weight -30/35/40',
          'Gas Pressure -0.4-0.6',
          ],
          manul:['Manual Paste']
    
      }
  return (
    <div className='prdmain'>
    <div className='head2'>
      <h1>Paste Filling Machine</h1>
    </div>
    <div className='items1'>
    <Prodcard1
        imageSrc={img14}
        model={"VP PF  100/500/1000)"}
        title="Paste Filling Machine"
        altText="img of websit"
        description={des.sam}
      />
      <Prodcard1
        imageSrc={img15}
        model={"VP 1000P"}
        title="Paste Filling Machine"
        altText="img of websit"
        description={des.sam}
      />
      <Prodcard1
        imageSrc={img16}
        model={"VP LF 100/500/1000"}
        title="Liquid Filling Machine"
        altText="img of websit"
        description={des.sam}
      />
       <Prodcard1
        imageSrc={img17}
        model={"VP 50"}
        title="Manual Paste Filling Machine!"
        altText="img of websit"
        description={des.manul}
      />

    </div>


  </div>
  )
}
